import _ from 'lodash'
import Backbone from 'backbone'
import template from './column-equation.hbs'
import EquationEditor from 'scoreboard/components/equations/equation-editor'
import columnEquationParser from './column-equation-parser'
import attachFieldDropdown from './attach-field-dropdown'

const ColumnEquation = Backbone.View.extend({

	tagName: 'form',

	className: 'equation-editor',

	events: {
		'change .column-dropdown': 'renderColumnsDropdown'
	},

	initialize: function(options) {
		this.options = options || {}
		this.equation = this.options.equation
		this.optionData = this.options.optionData
	},

	render: function() {
		this.$el.empty().append(template(this.options))

		//build the columns available to add
		let { optionData, model } = this
		attachFieldDropdown({
			el: this.$('.column-dropdown'),
			optionData,
			dataset: model.get('dataset')
		})

		this.equationEditor = new EquationEditor({
			el: this.el,
			equation: this.equation,
			equationParser: columnEquationParser(this.optionData),
			equationFormatter: {
				format: function(val) {
					return val.fieldIdOrColumnType
				}
			},
			allowCleanSubmission: true,
			required: true
		})
		this.equationEditor.on('submit', this._submit.bind(this))

		// important: this goes after all the event handlers are setup
		this.equationEditor.render()

		return this
	},

	_submit: function() {
		let equation = this.equationEditor.getCleanEquation()
		this.trigger('done', equation)
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.equationEditor], 'remove')
	}

})

export default ColumnEquation

ColumnEquation.__filename__ = 'reports/common/column-equation.js'
